<template>
  <div class="page">
    <navigator-menu></navigator-menu>
    <div class="login-form">
      <el-form ref="form" :model="loginForm" :rules="loginRules">
      <div>
        <h3>ITAKE Login</h3>
      </div>
      <el-form-item prop="username" style="margin-top:30px;">
        <el-input prefix-icon="avatar" placeholder="Username" ref="username" v-model="loginForm.username"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input prefix-icon="lock" placeholder="Password" ref="password" v-model="loginForm.password" show-password></el-input>
      </el-form-item>
      <el-button type="primary" style="width:100%;margin:10px 0 5px 0;" @click="handleLogin">Login</el-button>
      <el-button type="text" style="margin:5px 0px 10px 0px;" @click="toRegister">Register</el-button>
<!--      <el-checkbox v-model="rememberUser" style="margin:0px 0px 10px 200px;">记住我</el-checkbox>-->
<!--      <div style="text-align:center">-->
<!--        <el-link type="primary" style="margin:0px 8px">用户协议</el-link>-->
<!--        <el-link type="primary" style="margin:0px 8px">隐私条款</el-link>-->
<!--      </div>-->
      </el-form>
    </div>
  </div>
</template>

<script>
import NavigatorMenu from "./Navigation";
import axios from 'axios'
import Qs from 'qs'
export default {
    name: "Login",
    components: {
        NavigatorMenu,
    },
    data() {
        return {
            csrfToken: '',
            uId: -1,
            loginForm: {
              username: '',
              password: ''
            },
            loginRules: {
                username: [
                    { required: true, message: '用户名不能为空', trigger: 'blur' },
                    { min: 3, max: 20, message: '3~20位英文字母或数字', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '密码不能为空', trigger: 'blur' },
                    { min: 5, max: 20, message: '5~20位英文字母、数字或特殊符号', trigger: 'blur' }
                ],
            },
            rememberUser: false,
        };
    },
    created() {
        console.log('get cookie.')
        console.log(document.cookie)
        axios({
          method: 'post',
          url: 'api/login_2',
          headers: {},
          params: {},
          // params: sendData,
        }).then((response) => {
          console.log(response)

          var strcookie = document.cookie;//获取cookie字符串
          var arrcookie = strcookie.split("; ");//分割
          //遍历匹配
          for ( var i = 0; i < arrcookie.length; i++) {
            var arr = arrcookie[i].split("=");
            if (arr[0] == "csrftoken"){
              this.csrfToken = arr[1];
            }
          }
          // this.csrfToken = response.data.token
          if (!this.csrfToken){
            console.log("gogogo")
            location.reload()
          }
          console.log('csrfToken:'+this.csrfToken)
        }).catch((error) => {
          console.log('Unexpected error!')
          console.log(error)
        })
    },
    methods: {
      getCookie(name){
        console.log('cookie:'+document.cookie)
        var strcookie = document.cookie;//获取cookie字符串
        var arrcookie = strcookie.split("; ");//分割
        //遍历匹配
        for ( var i = 0; i < arrcookie.length; i++) {
          var arr = arrcookie[i].split("=")
          if (arr[0] == name){
            return arr[1]
          }
        }
        return ""
      },
      // 部署版本和非部署版本通用
      handleLogin(){
        if(this.loginForm.username=="" || this.loginForm.password==""){
          console.log('You can\'t login now.')
          return;
        }
        var formData =  Qs.stringify({
          csrfmiddlewaretoken: this.csrfToken,
          username: this.loginForm.username,
          password: this.loginForm.password,
        });
        axios.all([
          axios({
            method: 'post',
            url: 'api/login',
            headers:{
              'X-CSRFToken': this.csrfToken,
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: formData,
          }),
        ]).then((response) => {
          console.log(response)
          if(response[0].status==200){
            console.log('账号密码匹配！登陆成功！')
            this.$Global.isLogin = true
            this.$router.push({
              name: 'Projects',
            })
          }
        }).catch((error) => {
          console.log(error.response)
          window.alert(error.response.data)
        })
      },
      toRegister(){
        this.$router.push({
          name: 'Register',
        })
      },
    },
}
</script>

<style>
.page {
  padding: 0;
  margin: -8px;
  height: 100%;
  width: 100%;
  position:fixed;
  background-image: url("../assets/images/weiminghu.jpeg");
  background-size:cover;
}
.login-form{
  width: 350px;
  height: 420px;
  background-image: none;
  background-color: white;
  float: left;
  border-radius: 10px;
  padding: 10px 25px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 60;
}
</style>